import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    event.preventDefault();

    this.resetHiddenFields()
    // 送適用商品type
    this.setApplicableType()
    // 送排除轉單/ingram/honya
    this.setExcludeType()
    // 送同商品是否可重複加入優惠
    this.setCanAddMultiQty()
    // 送是否可參加購物車促案
    this.setCanRunWithCartPromotion()
    // 送活動類型(total_price/discount_rate)
    this.setDiscountType()
    // 送滿件數量(quantity)
    this.setComboQty()
    // 送活動優惠(discount_rate)
    this.setComboDiscount()
    // 點擊combo_offer_form的submit
    document.getElementById('combo_offer_form_btn').click();
  }

  resetHiddenFields() {
    let hiddenFieldDivs = document.querySelectorAll('#need_reset_hidden_fields div');

    hiddenFieldDivs.forEach((div) => {
      let inputs = div.querySelectorAll('input');
      inputs.forEach((element) => {
        element.parentNode.removeChild(element);
      });
    });
  }

  setApplicableType() {
    let selectedValue;
    const radios = document.querySelectorAll('input[type="radio"][name="combo_offer[applicable_type]"]');
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })
    let hiddenFieldDiv = document.querySelector("#applicable_type");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_offer[applicable_type]";
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setExcludeType(event) {
    const excludeTypes = document.querySelectorAll(`input[name='combo_offer[exclude_type]']`)
    const hiddenFieldContainer = document.getElementById("hidden_exclusive_type");
    excludeTypes.forEach((type) => {
      let value;
      if (type.checked) {
        value = true;
      } else {
        value = false;
      }

      let exclusiveTypeHiddenField = document.createElement("input");
      exclusiveTypeHiddenField.type = "hidden";
      exclusiveTypeHiddenField.name = `combo_offer[${type.value}]`;
      exclusiveTypeHiddenField.value = value;
      hiddenFieldContainer.appendChild(exclusiveTypeHiddenField);
    });
  }

  setCanAddMultiQty() {
    let selectedValue = document.getElementById("can_add_multi_qty").value;
    let hiddenFieldDiv = document.getElementById("can_add_multi_qty_div");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_offer[can_add_multi_qty]";
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setCanRunWithCartPromotion() {
    let selectedValue = document.getElementById("run_with_cart_promotion").value;
    let hiddenFieldDiv = document.getElementById("run_with_cart_promotion_div");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_offer[run_with_cart_promotion]"; // 替換成你想要的 name
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setDiscountType() {
    const radios = document.getElementsByName('combo_discount_setting[discount_type]');
    let selectedValue
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })
    let hiddenFieldDiv = document.getElementById("discount_type_div");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_discount_setting[discount_type]"; // 替換成你想要的 name
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setValue(fieldName, divId, hiddenFieldName) {
    let elements = document.querySelectorAll(`[name="${fieldName}"]`);
    let values = Array.from(elements).filter(element => element.value !== '').map(element => element.value);

    if (values.length > 0) {
      let hiddenFieldDiv = document.getElementById(divId);
      values.forEach(value => {
          const typeHiddenField = document.createElement("input");
          typeHiddenField.type = "hidden";
          typeHiddenField.name = `${hiddenFieldName}[]`;
          typeHiddenField.value = value;
          hiddenFieldDiv.appendChild(typeHiddenField)
      });
    }
  }

  setComboQty() {
    this.setValue("combo_qty", "combo_qty_div", "combo_discount_setting[combo_qty]");
  }

  setComboDiscount() {
    this.setValue("combo_discount", "combo_discount_div", "combo_discount_setting[discount_rate]");
  }
}
